import { MenuItem } from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import { observer } from "mobx-react-lite";
import type { ProjectListNavbarStore } from "../store";

type ExportProjectsEffectivenessButtonProps = {
  store: ProjectListNavbarStore;
};

export const ExportTriadProjectsEffectivenessButton = observer(
  function ExportEffectivenessButton({
    store,
  }: ExportProjectsEffectivenessButtonProps) {
    if (store.isTriadProjectsEffectivenessExportDisabled) {
      return null;
    }

    return (
      <MenuItem
        isDisabled={store.isExporting}
        onClick={store.exportTriadProjectsEffectiveness}
      >
        <Trans>Project Effectiveness</Trans>
      </MenuItem>
    );
  },
);
